
const digest = 'b5abbf790a82994ba18433463f6e3cddc816e0c87ef9f3aa85520bb1dd1143a8';
const classes = {"wrapper":"_wrapper_1nutc_1","textArea":"_textArea_1nutc_6","suffix":"_suffix_1nutc_37","prefix":"_prefix_1nutc_46","withPrefix":"_withPrefix_1nutc_55","withSuffix":"_withSuffix_1nutc_59","errorMessage":"_errorMessage_1nutc_63","invalid":"_invalid_1nutc_69"};
const css = `._wrapper_1nutc_1 {
  position: relative;
  display: flex;
}

._textArea_1nutc_6 {
  width: -webkit-fill-available;
  min-height: 55px;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 400;
  padding: 16px 20px;
  color: #000;
  border: 1px solid #c1cbe4 !important;
  border-radius: 15px;
  box-shadow: inset 0 3px 0 0 rgba(198, 214, 240, 0.5);
  background-color: #dce7fa;
  flex: 1;
}
._textArea_1nutc_6:disabled {
  background-color: #f3f3f3;
  opacity: 1;
}
._textArea_1nutc_6:focus {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  color: #000;
}
._textArea_1nutc_6[type=number]::-webkit-outer-spin-button, ._textArea_1nutc_6[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  display: none;
}
._textArea_1nutc_6[type=number] {
  -moz-appearance: textfield;
}

._suffix_1nutc_37 {
  font-family: Poppins, sans-serif;
  position: absolute;
  font-size: 14px;
  color: #1665d8;
  right: 25px;
  bottom: 17px;
}

._prefix_1nutc_46 {
  left: 20px;
  font-family: Poppins, sans-serif;
  position: absolute;
  font-size: 14px;
  color: #1665d8;
  bottom: 17px;
}

._withPrefix_1nutc_55 {
  padding-left: 35px !important;
}

._withSuffix_1nutc_59 {
  padding-right: 35px !important;
}

._errorMessage_1nutc_63 {
  font-family: Poppins, sans-serif;
  font-size: 14px;
  color: #d81616;
}

._invalid_1nutc_69 {
  border-color: #d81616 !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 0.1875rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  